import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-close" viewBox="0 0 16 16">
                <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"></path>
            </svg>
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-pl-2 ns-pr-2 ns-pt-2 ns-pb-2">
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            class="ns-selected-filter ns-d-flex ns-align-items-center ns-p-2 ns-mr-3 ns-mb-1 ns-font-3"
                        >
                            <span class="ns-color-black" style="line-height: 1;">
                                {filter.value}
                            </span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                <span
                    class="ns-anchor ns-text-align-right ns-color-black ns-font-3 ns-ml-2 ns-mr-auto ns-ml-0"
                    style="text-transform: uppercase; text-decoration: underline;"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear ALL
                </span>
            </div>
        )
    )
}
